import * as __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__ from "@sentry/react";
const getIntegrations = ({ replaysOnErrorSampleRate, jsBuildFilterKey, tracesSampleRate })=>{
    const integrations = [
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.httpContextIntegration(),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.dedupeIntegration(),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.inboundFiltersIntegration(),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.functionToStringIntegration(),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.breadcrumbsIntegration({
            console: false,
            dom: true,
            fetch: true,
            history: true,
            xhr: true
        }),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.extraErrorDataIntegration(),
        __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.sessionTimingIntegration()
    ];
    if (jsBuildFilterKey) integrations.push(__WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.thirdPartyErrorFilterIntegration({
        filterKeys: [
            jsBuildFilterKey
        ],
        behaviour: 'apply-tag-if-exclusively-contains-third-party-frames'
    }));
    if (tracesSampleRate && tracesSampleRate > 0) integrations.push(__WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.browserTracingIntegration());
    if (replaysOnErrorSampleRate && replaysOnErrorSampleRate > 0) integrations.push(__WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.replayIntegration());
    return integrations;
};
const integrations_rslib_entry_ = getIntegrations;
export { integrations_rslib_entry_ as default };

//# sourceMappingURL=integrations.mjs.map